module.exports = __webpack_public_path__ + "img/21.5eb93a13.svg";